<div class="icon-wrapper" *ngIf="error">
    <span class="ham-icon"> <i class="exclamation-outline-icon"></i> </span>
</div>
<!-- Loading Spinner -->
<div *ngIf="isLoading" class="loading-container">
    <div class="spinner"></div>
    <h1>Signing you in...</h1>
    <p>Please wait while we authenticate your account.</p>
</div>

<!-- Error State -->
<div *ngIf="!isLoading && error" class="sso-callback-page-error">
    <h1>Authentication Error</h1>
    <p>{{ error }}</p>

    <div *ngIf="error">
        <p>
            It looks like you don't have access to Aumico through your organization's Single Sign-On. Please reach out
            to your IT department to request access.
        </p>
    </div>

    <div class="button-wrapper">
        <ham-button variant="white" (buttonClick)="backToSsoLoginPage()" type="submit"> Try Again </ham-button>
        <ham-button (buttonClick)="router.navigate(['/auth/login'])" type="submit"> Back to Login </ham-button>
    </div>
</div>
